var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-markdown',{staticClass:"markdown",attrs:{"html":false,"source":_vm.content,"breaks":true,"linkify":true,"anchor-attributes":{
  rel: 'noopener noreferrer'
}}})
}
var staticRenderFns = []

export { render, staticRenderFns }